import type React from 'react';

import type { WithDataTestid } from '@vlabs/uikit/types';
import cn from 'classnames';

import st from './DetectionPoint.module.sass';
import { buildTestid } from '../../../lib/utils';
import type { DetectionColor } from '../../color-picker';

export interface DetectionPointProps extends WithDataTestid {
  coordinates: [number, number];
  color?: DetectionColor;
  size?: number;
}

const getOutlineSize = (size: number): number => {
  if (size <= 8) return 2;
  if (size <= 20) return 3;
  return 4;
};

const displayName = 'DetectionPoint';
const testid = buildTestid(displayName);

function DetectionPoint({
  coordinates,
  color = 'positive',
  size = 6,
  'data-testid': dataTestId,
}: DetectionPointProps): React.JSX.Element | null {
  if (!coordinates) return null;

  const [x, y] = coordinates;
  const outlineSize = getOutlineSize(size);

  return (
    <div
      className={cn(st.DetectionPoint, st[`DetectionPoint_${color}`])}
      style={{
        top: y,
        left: x,
        width: size,
        height: size,
        outlineWidth: outlineSize,
      }}
      {...testid(dataTestId)}
    />
  );
}

DetectionPoint.displayName = displayName;

export { DetectionPoint };
